<template>
  <div class="main-content-p" v-if="contentIsShow">
    <h3 class="content-title-p">{{title}}</h3>
    <ul>
      <li v-for="(item,index) of postData" :key="index" class="content-item-p">
        <div v-if="item.type=='文字'" class="content-text-p">
          <p>{{item.content}}</p>
        </div>

        <div
          v-for="(img,imgIndex) of item.type=='图片' ? item.content.split(',') : ''"
          :key="imgIndex"
          class="content-img-p"
          :class="{oneImg:item.content.split(',').length == 1}"
          @click="showImg(item.content.split(','),imgIndex)"
        >
          <img :src="img" alt />
        </div>

        <div v-if="item.type=='节点'" class="content-node-p" ref="node">
          <div class="content-node-state-p" :class="changeNodeClass(item.content.nodeState)">
            <p>{{item.content.nodeName}}</p>
            <div class="content-state-box-p">
              <span>{{changeNodeText(item.content.nodeState)}}</span>
              <img :src="changeNodeImg(item.content.nodeState)" alt />
            </div>
          </div>
          <div class="content-node-remark-p">
            <p>{{item.content.remark}}</p>
          </div>
          <div
            v-for="(nodeImg,nodeImgIndex) of item.content.img"
            :key="nodeImgIndex"
            class="content-ndoe-img-p"
            :class="{oneImg:item.content.img.length == 1}"
            @click="showImg(item.content.img,nodeImgIndex)"
          >
            <img :src="nodeImg" alt />
          </div>
        </div>
      </li>

      <li>
        <score-table :value="pointArr" :processWidth="312" class="score-table-p"></score-table>
      </li>
      <li v-if="Object.keys(postUser).length > 0">
        <div class="content-user-p">
          <p>检查人：</p>
          <div class="user-box-p">
            <img :src="postUser.headImage" alt />
            <p>{{postUser.nickName}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import "../../../../../html/components/postDetail/mainContent.scss"

import scoreTable from "../../createQE/components/scoreTable.vue"
import { getJxjPostDetail} from '../../../../../api/index';
import timeago from '../../../../../pubilc/util/timeago';
import stars from '../../../../../pubilc/util/stars';

export default {
  name: 'mainContent',
  data() {
    return {
      normalImg: require('../../../../../html/pages/originality/qe/images/normal1.png'),
      abnormalImg: require('../../../../../html/pages/originality/qe/images/abnormal1.png'),
      warnlImg: require('../../../../../html/pages/originality/qe/images/warn1.png'),
      qualityOptions: ["各道工序核验情况", "使用材料检测报告", "现场核验实测数据", "整改建议及复核情况", "现场材料管理情况", "现场人员环境安全情况", "实现途径"],
      qualityTotalScore: [30, 10, 20, 10, 10, 10, 10],
      materialOptions: ["材料放置情况", "材料放置场地合理情况", "现场材料使用情况", "使用未完材料归来情况"],
      materialTotalScore: [25, 25, 25, 25, ],
      
      materialOptions2: ["材料放置情况", "材料放置场地合理情况", "现场材料使用情况", "使用未完材料归来情况","施工方案","安全交底","资料","印章规范使用情况"],
      materialTotalScore2: [25, 25, 25, 25, 25, 25, 25, 25],
      pointArr: [],
      contentIsShow: true,
      today_time:''
    }
  },
  props: {
    postData: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String,
      default: "质量安全篇"
    },
    pointList: {
      type: Array,
      default() {
        return []
      }
    },
    postUser: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    changeNodeText(state) {
      switch (state) {
        case 1:
          return "良好";
        case 2:
          return "预警";
        case 3:
          return "异常";
      }
    },
    changeNodeImg(state) {
      switch (state) {
        case 1:
          return this.normalImg;
        case 2:
          return this.abnormalImg;
        case 3:
          return this.warnlImg;
      }
    },
    changeNodeClass(state) {
      switch (state) {
        case 1:
          return "state1";
        case 2:
          return "state2";
        case 3:
          return "state3";
      }
    },
    showImg(imgList, index) {
      this.$emit("openPopImgList", imgList, index)
    }
  },
  components: {
    scoreTable
  },
  async mounted() {
    let res = await getJxjPostDetail({
        id: this.$route.params.id
      });

      if (res.Type == 'Success') {
        res.Data.timeAgo = timeago(new Date(res.Data.createdTime));
        
        let ti = res.Data.createdTime.split(' ')[0].split('-');
        this.today_time = ti[0] + '-' + ti[1] + '-' + ti[2]
        console.log(this.today_time)
      } else {
        this.$layer.alert(res.Content);
      }
      if(this.today_time>='2020-06-1'){
        this.materialTotalScore2=[20, 20, 30, 20, 30, 30, 30, 20]
      }else{
        this.materialTotalScore2=[25, 25, 25, 25, 25, 25, 25, 25]
      }
    this.pointList.forEach((item, i, arr) => {
      if (arr.length == 7) {
        this.pointArr.push({
          option: this.qualityOptions[i],
          totalScore: this.qualityTotalScore[i],
          score: item
        })
      } else if (arr.length == 4) {
        this.pointArr.push({
          option: this.materialOptions[i],
          totalScore: this.materialTotalScore[i],
          score: item
        })
      }else if (arr.length==8){
        this.pointArr.push({
          option:this.materialOptions2[i],
          totalScore: this.materialTotalScore2[i],
          score: item
        })
      }
    })
  }
}
</script>

<style scoped>
</style>
